import { Routes } from '@angular/router';
import { authGuard } from '../../core/guards/auth.guard';
import { menuAccessGuard } from '../../core/guards/menu-access.guard';

function withAuthGuard(routes: Routes): Routes {
    return routes.map((route) => ({
        ...route,
        canActivate: route.canActivate
            ? [authGuard, menuAccessGuard, ...route.canActivate]
            : [authGuard, menuAccessGuard],
    }));
}

export const adminRoutes: Routes = withAuthGuard([
    { title: 'Transmaritime - Home', path: 'home', loadComponent: () => import('../../shared/features/home/pages/home.component').then(m => m.HomeComponent) },
    {
        title: 'Transmaritime - ACH Receipt Approval',
        path: 'approval-ach-receipts',
        loadComponent: () =>
            import(
                '../admin/approval-ach-receipts/pages/approval-ach-receipts'
            ).then((m) => m.ApprovalAchReceipts),
    },
    {
        title: 'Transmaritime - Pagos sin respuesta de bancos',
        path: 'empty-cart',
        loadComponent: () =>
            import('../admin/empty-cart/pages/empty-cart').then(
                (m) => m.EmptyCart,
            ),
    },
]);
